export const systemTypeEnum = Object.freeze({
	USER: 1,
	COMPANY: 2,
	CUSTOMER: 3,
	AGREEMENT: 4,
	PERSONGROUP: 5,
	PERSON: 6,
	PRODUCT: 7,
	PRODUCTPACKAGE: 8,
	MEDIA: 9,
	ORDER: 10,
	CLIENT: 11
});

export const authenticationEnum = Object.freeze({
	NOT_LOGGED_IN: 0, // No authentication data found
	LOGGED_IN: 1, // Valid authentication data found
	TOKEN_EXPIRED: 2, // Authentication data expired
});

export const appBusyStateEnum = Object.freeze({
	IDLE: 1,
	BUSY: 2,
	BUSYMODAL: 3,
});

export const componentBusyStateEnum = Object.freeze({
	IDLE: 1,
	BUSY: 2
});

export const appFeedbackStateEnum = Object.freeze({
	NONE: 1,
	SUCCESS: 2,
	ADDED: 3,
	UPDATED: 4,
	DELETED: 5,
	FAILED: 6
});

export const importPersonsAndGroupsModeEnum = Object.freeze({
	VALIDATE: "validate",
	READYFORIMPORT: "readyforimport",
	VALIDATIONFAILED: "validationfailed",
	IMPORT: "import",
	IMPORTFAILED: "importfailed",
	IMPORTSUCCESS: "importsuccess"
});

export const productTypeEnum = Object.freeze({
	PORTRAIT: 1,
	GROUPPHOTO: 2,
	VIDEO: 3,
	USBSTICK: 4,
	BOOK: 5,
	OTHER: 6
});

export const productPackageTypeEnum = Object.freeze({
	PICTUREPACKAGE: 1,
	PICTUREPACKAGEEXTRA: 4,
	PICTUREPACKAGESECONDARY: 7,
	AFTERPICTUREPACKAGE: 6,
	WITHOUTPICTUREPACKAGE: 5,
	ADDON: 2,
	FREIGHTANDSERVICE: 3,
	FREIGHTANDSERVICEREQUIRED: 8
});

export const personTypeEnum = Object.freeze({
	CLIENT: 1,
	CHILD: 2,
	NONCLIENT: 3,
	EMPLOYEE: 4
});

export const generatedFileTypeEnum = Object.freeze({
	AGREEMENT: 1,
	ALLGROUPS: 2,
	GROUP: 3,
	PERSON: 4,
	CUSTOMEREMAILEXPORT: 5,
	CUSTOMERLOWRESIMAGESEXPORT: 6,
	ORDERSDETAILS: 7,
	DELIVERYNOTES: 8
});

export const generatedFileStatusEnum = Object.freeze({
	INITIAL: 1,
	CONFIGERROR: 2,
	RUNNING: 3,
	ERROR: 4,
	SUCCESS: 5
});

export const orderStatusEnum = Object.freeze({
	// NOTCREATED: 0,
	DRAFT: 1,
	READY: 2,
	// READYCLIENTNOTIFIED: 3,
	// CLIENTREQUESTEDRESHOOT: 4,
	// CANCELLED: 5,
	COMPLETED: 6,
	DELIVERED: 7,
	REFUNDED: 8,
	PAYMENTLINKSENT: 9,
	PAYMENTREMINDERSENT: 10,
	COMPLETEDWITHPAYMENTLINK: 11,
	COMPLETEDNORMALLY: 12
});

export const personStatusEnum = Object.freeze({
	CREATED: 0,
	READY: 1,
	READYCLIENTNOTIFIED: 2,
	CLIENTREQUESTEDRESHOOT: 3,
	CANCELLED: 4
});

export const orderPaymentStatusEnum = Object.freeze({
	AWAITING: 1,
	SUCCEEDED: 2,
	FREE: 3,
	REJECTED: 4
});

export const mediaPropertiesList = Object.freeze(
	[
		{
			systemname: "BlackAndWhitePhotograph",
			name: "Sort/Hvid",
			value: 1
		},
		{
			systemname: "ColorPhotograph",
			name: "Farve",
			value: 2
		}
	])

export const personStatusTypeEnum = Object.freeze({
	CREATED: 0,
	READY: 1,
	READYCLIENTNOTIFIED: 2,
	CLIENTREQUESTEDRESHOOT: 3,
	CANCELLED: 4
});